module.exports = __webpack_public_path__ + "img/wallpaper.32673e87.png";